import React from 'react';

import { SvgIconProps } from '@mui/material';

import { StyledSelectArrow } from './styled';

interface PropsType extends SvgIconProps {
	isOpen: boolean;
}

function SelectArrow({ isOpen, ...props }: PropsType) {
	return <StyledSelectArrow isOpen={isOpen} {...props} />;
}

export default SelectArrow;
